import React from 'react';
import Header from './Header';
import Footer from './Footer';
import { useNavigate } from 'react-router-dom';

function Layout(props) {
    const navigate = useNavigate();
    
   /* style={{ Width: '100%', maxWidth: '100%' }}*/
    return (
        <div>
            <div className="container-fluid"  >
                <Header />
                <div className="" >
                {props.children}
            </div>
                              
            <Footer />
            </div>

        </div>
    );
}
export default Layout;